import React, { useEffect, useRef } from "react";
import MetaTags from "react-meta-tags";
import { Image } from "antd";
import "./index.css";
import DashboardLogo from "../../assets/images/dashboard.jpg";
import DashboardLogo1 from "../../assets/images/city.jpg";
import DashboardLogo2 from "../../assets/images/travel2.jpg";
import { isEmpty } from "lodash";
// import axiosInstance from "../../helpers";
import { useDispatch } from "react-redux";
import { dashboardMeApi } from "../../store/My-Account/actions";

function Dashboard() {
  const userDetails = localStorage.getItem("sessionUser");

  console.log(userDetails, "userDetails");

  const userInfo = !isEmpty(userDetails) ? JSON.parse(userDetails) : "";
  console.log(userInfo, "userInfo");

  const userInfoDetails =
    !isEmpty(userInfo) &&
    userInfo.data &&
    userInfo.data.data &&
    userInfo.data.data.user
      ? userInfo.data.data.user
      : "";

  // useEffect(()=> {
  //   axiosInstance
  //   .post("/Api/me")
  //   .then((res) => {
  //     return res.data;
  //   })
  //   .catch((error) => {
  //     return Promise.reject(error);
  //   });
  // }, [1])

  const dispatch = useDispatch();
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      dispatch(dashboardMeApi());
      // axiosInstance
      // .get("/Api/me")
      // .then((res) => {
      //   return res.data;
      // })
      // .catch((error) => {
      //   return Promise.reject(error);
      // });

      isInitialRender.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {/* <Layout> */}
      <div className="pl-10 pr-10">
        <MetaTags>
          <title>Dashboard | PMT</title>
        </MetaTags>
        {/* <Breadcrumb
          className="mt-4"
          items={[
            {
              title: "Home",
            },
            {
              title: <p>Dashboard</p>,
            },
          ]}
        /> */}

        <div className="mt-5">
          <p
            style={{
              fontFamily: "Poppins",
            }}
            className="text-[16px] dashboard-header mt-4 mr-4 font-semibold"
          >
            Welcome{" "}
            {" " + !isEmpty(userInfoDetails.first_name)
              ? userInfoDetails.first_name
              : " " + !isEmpty(userInfoDetails.last_name)
              ? userInfoDetails.first_name
              : ""}
          </p>
          <div className="dashboard-image-card">
            <div className="dashboard-image-main">
              <Image
                src={DashboardLogo}
                height={300}
                className="w-[100%] mt-3 pr-3 mb-3 rounded-lg"
                preview={false}
              />
            </div>
            <div className="dashboard-image-main">
              <Image
                src={DashboardLogo1}
                height={300}
                className="w-[100%] mt-3 pr-3 mb-3 rounded-lg"
                preview={false}
              />
            </div>
            <div className="dashboard-image-main">
              <Image
                src={DashboardLogo2}
                height={300}
                className="w-[100%] mt-3 pr-3 mb-3 rounded-lg"
                preview={false}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Dashboard;
